/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import Patient from './Patient/index'
import Professional from './Professional/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/ReferralSource/Content/Content/Referrals/Referral/Source/Search/Preview/Details"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let referralTemplateTextValueData = fromData.useDataValue({ viewPath,
context: 'referral',
path: 'template.text',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: referralTemplateTextValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Patient'}>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Professional'}>
<Professional
  viewPath={`${viewPath}/Professional`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}